<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p class="social">
          <tooltip label="Home IoT TF Github" placement="top-right">
          <a :href="repository" target="_blank">
            <span class="icon">
              <i class="fab fa-github fa-lg"></i>
            </span>
          </a>
          </tooltip>
          &nbsp;
          <tooltip label="Home IoT TF Confluence" placement="top-right">
          <a href="http://suprem.sec.samsung.net/confluence/pages/viewpage.action?pageId=103470995" target="_blank">
            <span class="icon">
              <i class="far fa-clipboard fa-lg"></i>
            </span>
          </a>
          </tooltip>
          &nbsp;
          <tooltip v-if="isGroupMember ('admin')" label="Resident API Document" placement="top-right">
            <a :href="residentUrl" target="_blank">
              <span class="icon">
                <i class="far fa-file-alt fa-lg"></i>
              </span>
            </a>
          </tooltip>
          &nbsp;
          <tooltip label="Device API Document" placement="top-right">
          <a :href="deviceUrl" target="_blank">
            <span class="icon">
              <i class="far fa-file-alt fa-lg"></i>
            </span>
          </a>
          </tooltip>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import Tooltip from 'vue-bulma-tooltip'

export default {
  components: {
    Tooltip
  },

  data () {
    let pkg = this.$store.state.pkg
    let baseUrl = window.location.origin
    pkg.deviceUrl = baseUrl + '/api/v4/docs/device/'
    // if (this.$auth.check()) {
    pkg.residentUrl = baseUrl + '/api/v4/docs/resident/?access_token=' + this.$auth.token()
    // }
    pkg.cvnetUrl = baseUrl + '/api/v2/docs/cvnet/'
    return this.$store.state.pkg
  },

  methods: {
    isGroupMember (groupname) {
      if (this.$auth.check()) {
        for (let i = 0; i < this.$auth.watch.data['cognito:groups'].length; i++) {
          if (this.$auth.watch.data['cognito:groups'][i] === groupname) return true
        }

        return false
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/mixins';

.footer {
  margin-left: 230px;
  
  @include mobile() {
    margin-left: 0;
  }
  
  .social a {
    border-bottom: none !important;
  }

  .fa.fa-heart {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// FooterBar.vue?3a1f4b62